<template>
  <div>
    <b-card
      v-for="survey in surveyList"
      :title="survey.title"
      :key="survey.id"
      class="shadow atm-rounded my-2"
    >
      <b-container class="pl-0">
        <b-row>
          <b-col cols="12" md="9">
            <b-card-text>
              {{ survey.description }}
            </b-card-text>
          </b-col>
          <b-col cols="12" md="3" class="d-md-flex justify-content-end align-items-center py-4 p-md-0">
            <button
              class="atm-button bg-main d-flex flex-row gap-2 justify-content-center align-items-center"
              @click="goToSurvey(survey.url)"
            >
              Start Survey
              <i class="material-icons">
                launch
              </i>
            </button>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    surveyList: {
      type: Array,
      required: true,
    },
  },
  methods: {
    goToSurvey(url) {
      window.open(url, '_blank');
    },
  },
};
</script>
